module.exports = __webpack_public_path__ + "assets/img/4.9b61297e.png";